import React, { useState } from 'react'
import { Chip, DatePicker, Icon } from '@wework/dieter-ui'
import { DateUtils, RangeModifier } from 'react-day-picker'
import PopupAwayClick from '../PopupAwayClick'

export default function RangeFilterControl({
  label,
  date,
  onChange,
  onDelete,
  setChipLabel,
  disabled,
  minDate,
  maxDate,
  containerStyle,
}) {
  const [open, setOpen] = React.useState(false)

  let chipLabel = ''
  if (date && date.from && date.to) {
    chipLabel = setChipLabel(date)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleClick = () => {
    setOpen(!open)
  }

  const getInitialState = (): {
    from: Date | undefined
    to: Date | undefined
  } => ({
    from: undefined,
    to: undefined,
  })

  const [state, setState] = useState<{
    from: Date | undefined
    to: Date | undefined
  }>(getInitialState())

  // const handleDayClick = (day: Date) => {
  //   const range = DateUtils.addDayToRange(day, state as RangeModifier)
  //   setState(range)
  // }

  const handleResetClick = () => {
    setState(getInitialState())
  }
  const { from, to } = state

  return (
    <PopupAwayClick
      open={open}
      setter={setOpen}
      position="bottom left"
      closeOnTriggerMouseLeave={true}
      disabled={disabled}
      trigger={
        <Chip onClick={handleClick} primary={date} active={date}>
          {chipLabel ? chipLabel : label}
          <div
            style={{ display: 'inline', marginLeft: 8 }}
            onClick={() => {
              handleResetClick()
              handleClose()
              onDelete()
            }}
          >
            <Icon fitted name={open ? 'x' : 'caret down'} />
          </div>
        </Chip>
      }
      on="click"
      style={{ padding: 0, maxWidth: 'none' }}
      content={
        <DatePicker
          className="Selectable"
          numberOfMonths={2}
          selectedDays={[from, { from, to } as RangeModifier]}
          // selectedDays={date}
          modifiers={{ start: minDate, end: maxDate }}
          onDayClick={e => {
            const range = DateUtils.addDayToRange(e, state as RangeModifier)
            //@ts-ignore
            setState(range)
            // handleClose()
            onChange({ from: range.from, to: range.to })
          }}
        />
      }
    />

    // <FilterControl
    //   label={label}
    //   chipLabel={chipLabel}
    //   onDelete={() => {
    //     handleClose()
    //     onDelete()
    //   }}
    //   handleClick={handleClick}
    //   handleClose={handleClose}
    //   handleOnClickOutside={handleOnClickOutside}
    //   open={open}
    //   disabled={disabled}
    // >
    //   {/* <div className={classes.dateRangePicker}> */}

    //   {/* <DateRangePicker
    //       minDate={minDate}
    //       maxDate={maxDate}
    //       selected={date}
    //       open={open}
    //       definedRanges={[]}
    //       initialDateRange={{ startDate: date?.from, endDate: date?.to } || {}}
    //       onChange={changed => {
    //         handleClose()
    //         onChange({ from: changed.startDate, to: changed.endDate })
    //       }}
    //     /> */}
    //   {/* </div> */}
    // </FilterControl>
  )
}
